import firebase from 'firebase';

import { BASE_API } from '../config';

class SupportService {
  static async get(URL) {
    try {
      const token = await SupportService.getUserToken();
      const res = await fetch(BASE_API + URL, {
        method: 'GET',
        headers: {
          Authorization: token || '',
          'Content-Type': 'application/json',
        },
      });
      let result = null;
      result = await res.json();
      return result;
    } catch (err) {
      if (err.errorCode === 'auth/id-token-expired') {
        await SupportService.getUserToken(true);
      } else {
        throw err;
      }
    }
  }

  static async post(URL, body) {
    try {
      const token = await SupportService.getUserToken();
      const res = await fetch(BASE_API + URL, {
        method: 'POST',
        headers: {
          Authorization: token || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      let result = null;
      result = await res.json();
      return result;
    } catch (err) {
      if (err.errorCode === 'auth/id-token-expired') {
        await SupportService.getUserToken(true);
      } else {
        throw err;
      }
    }
  }

  static async put(URL, body) {
    try {
      const token = await SupportService.getUserToken();
      const res = await fetch(BASE_API + URL, {
        method: 'PUT',
        headers: {
          Authorization: token || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      let result = null;
      result = await res.json();
      return result;
    } catch (err) {
      if (err.errorCode === 'auth/id-token-expired') {
        await SupportService.getUserToken(true);
      } else {
        throw err;
      }
    }
  }

  static async delete(URL, body) {
    try {
      const token = await SupportService.getUserToken();
      const res = await fetch(BASE_API + URL, {
        method: 'DELETE',
        headers: {
          Authorization: token || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      let result = null;
      result = await res.json();
      return result;
    } catch (err) {
      if (err.errorCode === 'auth/id-token-expired') {
        await SupportService.getUserToken(true);
      } else {
        throw err;
      }
    }
  }

  static async getUserToken(forceRefresh) {
    const user = firebase.auth().currentUser;
    if (user && user.uid) {
      return await user.getIdToken(forceRefresh);
    }
    return null;
  }
}

export default SupportService;